import config from 'config';
import { authHeader, loggedInUser } from '@mobile/services/user';
import quietAxios from '@mobile/util/quietAxios';

export default {
    register,
    unregister,
    subscribe,
    unsubscribe,
};

async function register(subscription) {
    const request = {
        headers: authHeader(),
        data: subscription,
        method: 'post',
        url: `${config.apiUrl}/${config.apiVersion}/push/register`,
    };

    const sendRequest = await quietAxios(request);
    if (sendRequest && sendRequest.status == 200) {
        return sendRequest.data;
    }
}

async function unregister(subscription) {
    const request = {
        headers: authHeader(),
        data: subscription,
        method: 'post',
        url: `${config.apiUrl}/${config.apiVersion}/push/unregister`,
    };

    const sendRequest = await quietAxios(request);
    if (sendRequest && sendRequest.status == 200) {
        return sendRequest.data;
    }
}

async function subscribe() {
    if (
        !loggedInUser()
        || !navigator.serviceWorker
        || !navigator.serviceWorker.controller
    ) {
        return Promise.resolve();
    }

    const registration = await navigator.serviceWorker.ready;

    if (!registration.pushManager) {
        return Promise.resolve();
    }

    const subscriptionParameters = {
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(config.vapidPublicKey),
    };

    let subscription;

    try {
        subscription = await registration.pushManager.subscribe(
            subscriptionParameters,
        );
        return await register(subscription);
    } catch (e) {
        console.log('Error subscribing to push notifications.');
        return Promise.resolve();
    }
}

async function unsubscribe() {
    if (
        !loggedInUser()
        || !navigator.serviceWorker
        || !navigator.serviceWorker.controller
    ) {
        return Promise.resolve();
    }

    const registration = await navigator.serviceWorker.ready;

    if (!registration.pushManager) {
        return Promise.resolve();
    }

    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
        await unregister(subscription);
        await subscription.unsubscribe();
    }

    return Promise.resolve();
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
